/**
 * Mini SPA router — Svelte 5 runes, sem dependências externas.
 * Suporta rotas estáticas + parâmetros :param, e wildcard (rota default).
 */

function createRouter() {
  let path = $state(window.location.pathname);
  let params = $state<Record<string, string>>({});

  function navigate(to: string, replace = false) {
    if (replace) {
      history.replaceState(null, "", to);
    } else {
      history.pushState(null, "", to);
    }
    path = window.location.pathname;
  }

  if (typeof window !== "undefined") {
    window.addEventListener("popstate", () => {
      path = window.location.pathname;
    });
  }

  return {
    get path() { return path; },
    get params() { return params; },
    navigate,
  };
}

export const router = createRouter();
export function navigate(to: string, opts?: { replace?: boolean }) {
  router.navigate(to, opts?.replace);
}
